module.exports = __webpack_public_path__ + "c1dab92b3ec8d04c4f8adfa6180a702c.png";